"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports["default"] = exports.availableProps = void 0;
var _react = _interopRequireDefault(require("react"));
var _selectors = require("../Theme/selectors");
var _template = _interopRequireDefault(require("./template"));
var _excluded = ["color"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var RugbyPosts = function RugbyPosts(_ref) {
  var color = _ref.color,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_template["default"], _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {};
      if (color) {
        style.fill = (0, _selectors.getColor)(uiTheme, color);
      }
      return /*#__PURE__*/_react["default"].createElement("path", {
        style: style,
        d: "M5,26 L9,26 C9.55228475,26 10,26.4477153 10,27 L10,35 C10,35.5522847 9.55228475,36 9,36 L5,36 C4.44771525,36 4,35.5522847 4,35 L4,27 C4,26.4477153 4.44771525,26 5,26 Z M10,17 L30,17 L30,20 L10,20 L10,17 Z M5.5,4 L8.5,4 L8.5,24.5 L5.5,24.5 L5.5,4 Z M31.5,4 L34.5,4 L34.5,24.5 L31.5,24.5 L31.5,4 Z M31,26 L35,26 C35.5522847,26 36,26.4477153 36,27 L36,35 C36,35.5522847 35.5522847,36 35,36 L31,36 C30.4477153,36 30,35.5522847 30,35 L30,27 C30,26.4477153 30.4477153,26 31,26 Z"
      });
    }
  }));
};
RugbyPosts.defaultProps = {
  color: null
};
var _default = exports["default"] = RugbyPosts;
var name = exports.name = 'RugbyPosts';
var availableProps = exports.availableProps = ['color'];